/** IST market session helpers (NSE/BSE cash hours). */

function istParts(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(now);
  const get = (type) => parts.find(p => p.type === type)?.value || '0';
  return {
    y: get('year'),
    m: get('month'),
    d: get('day'),
    h: Number(get('hour')),
    min: Number(get('minute')),
  };
}

export function todayISO(now = new Date()) {
  const { y, m, d } = istParts(now);
  return `${y}-${m}-${d}`;
}

/**
 * True when IST time is within the NSE cash/index regular session window.
 * Regular session: 09:15–15:30 IST inclusive (last prints at close).
 */
export function isMarketOpen(now = new Date()) {
  const { h, min } = istParts(now);
  if (h < 9 || (h === 9 && min < 15)) return false;
  if (h > 15 || (h === 15 && min > 30)) return false;
  return true;
}

/**
 * True while new bars may still open (09:15 ≤ t < 15:30 IST).
 * At 15:30 and after, no new candle opens should be created.
 */
export function isNseSessionCore(now = new Date()) {
  const { h, min } = istParts(now);
  const hm = h * 60 + min;
  return hm >= (9 * 60 + 15) && hm < (15 * 60 + 30);
}